import React, { useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Divider, Flex, Select } from 'antd';
import { InlineError, Text, Button, TextField } from '@shopify/polaris';
import { DI } from '../../../../Core';
import { useTranslation } from 'react-i18next';
let index = 0;

const PreviousAppInfo: React.FC = (props: any) => {
    const { t } = useTranslation();
    const [items, setItems] = useState([
        'Shopify Marketplace Connect',
        'Litextension',
        'Webbeeglobal',
        'Bespoke',
        'LitCommerce Amazon eBay Etsy +',
        'Amazon Integration Plus',
        'Amazon, eBay, Etsy — Salestio',
        'ChannelAdvisor'
    ]);

    const inputRef = useRef<any>(null);

    const [name, setName] = useState('');
    const [duplicateData, setDuplicateData] = useState(false);
    const onNameChange = (event: any) => {
        setDuplicateData(false)
        setName(event);
    };

    const addItem = () => {
        props?.errorHandler('previous_used_app_value', false);
        props?.errorHandler('previous_used_app', false);
        if (name.trim() !== "") {
            const newValues = [...props.previousUsedAppsValue];
            setTimeout(() => {
                if (inputRef.current) {
                    const inputElement = inputRef.current.querySelector('input');
                    if (inputElement) {
                        inputElement.focus();
                    }
                }
            }, 0);
            if (!items.includes(name.trim())) {
                setItems([...items, name.trim()]);
                !newValues.push(name.trim())
                props?.updateState('previousUsedAppsValue', "", "", [...newValues])
                setName('');
            } else {
                setDuplicateData(true)
            }
        }

    };

    const addOnenter = (e: string) => {
        props?.errorHandler('previous_used_app_value', false);
        props?.errorHandler('previous_used_app', false);
        if (e.trim() != "") {
            e = e.trim();
            if (!items.includes(e)) {
                setItems([...items, e]);
                const newValues = props.previousUsedAppsValue.filter((option: any) => option !== e); // Filter out options already in value
                newValues.push(e)
                props?.updateState('previousUsedAppsValue', "", "", [...newValues])
                setName('');
            }
            else {
                setDuplicateData(true)
            }
        }
    }

    const handleChange = (selectedOptions: string[]) => {
        props?.errorHandler('previous_used_app_value', false);
        props?.errorHandler('previous_used_app', false);
        props?.updateState('previousUsedAppsValue', "", "", [...selectedOptions])
    };

    const addBtnTxt:any =  <Text as='strong'> {t("Add More")}</Text>;

    return (
        <>
            <Select
                mode="multiple"
                status={props?.errors?.previous_used_app_value ? "error" : undefined}
                id='prevUsedApp'
                style={{ width: '100%' }}
                placeholder={t("Enter here")}
                value={props.previousUsedAppsValue}
                dropdownRender={(menu) => (
                    <>
                        {menu}
                        <Divider style={{ margin: '8px 0' }} />
                        <Flex gap="10px" align='' >
                            <div className='flex-1' ref={inputRef} onKeyDown={(e) => {
                                e.stopPropagation();
                                if (e.key === 'Enter') {
                                    addOnenter(name)
                                }
                            }}>
                                <TextField
                                    placeholder={t("Please enter the name of the App")}
                                    label
                                    labelHidden
                                    autoComplete='off'
                                    value={name}
                                    onChange={onNameChange}

                                />
                            </div>
                            <Button icon={<PlusOutlined />} onClick={addItem}>
                               {addBtnTxt}
                            </Button>
                        </Flex>
                        {duplicateData && <InlineError message={t("App name is already available")} fieldID={''} ></InlineError>}
                    </>
                )}
                onDeselect={(e) => { }}
                onChange={handleChange}
                options={items.map((item) => ({ label: item, value: item }))}
            />
            {props?.errors?.previous_used_app_value && <InlineError message={t("Kindly select atleast one App from list")} fieldID="prevUsedApp" />}

        </>

    );
};

export default DI(PreviousAppInfo);